const BookViaCallIcon = ({ className = '' }) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3478 17.3972C13.5217 21.5679 14.7547 31.516 22.2002 38.9628C29.647 46.4082 39.5949 47.6413 43.7658 47.8152C44.9773 47.865 46.1538 47.4082 47.0108 46.5498L51.2248 42.3372C52.2463 41.3158 52.2463 39.6596 51.2248 38.638L44.1567 31.5685C43.1352 30.547 41.479 30.547 40.4575 31.5685L34.97 37.0572C34.97 37.0572 31.729 35.9131 28.4893 32.6734C25.2497 29.4338 24.1056 26.1928 24.1056 26.1928L29.5943 20.7053C30.6158 19.6839 30.6158 18.0277 29.5943 17.0061L22.5248 9.93795C21.5033 8.91651 19.8471 8.91651 18.8256 9.93795L14.613 14.1519C13.7548 15.0092 13.298 16.1856 13.3478 17.3972Z"
        fill="#3EADFF"
      />
      <path
        d="M51.2248 42.336L47.0109 46.5499C46.1538 47.4084 44.9774 47.8653 43.7658 47.8153C39.5951 47.6402 29.647 46.4084 22.2002 38.963C14.7547 31.5161 13.5217 21.5682 13.3478 17.3959C13.2979 16.1844 13.7548 15.0094 14.6132 14.1509L15.7465 13.0176C16.4001 18.695 20.5251 43.3466 42.7215 40.8401C45.8775 40.4844 48.3463 39.3591 50.2532 37.6652L51.2248 38.6368C52.2464 39.6597 52.2464 41.3145 51.2248 42.336Z"
        fill="#258DCE"
      />
      <path
        d="M19.6104 11.0852L17.6566 12.946C17.6566 12.946 21.4298 12.6765 24.9336 14.4284L21.3684 11.0791C20.8736 10.6145 20.1019 10.6172 19.6104 11.0852Z"
        fill="#92D6FF"
      />
      <path
        d="M41.3359 32.8109L39.3821 34.6717C39.3821 34.6717 43.1553 34.4021 46.6591 36.154L43.0939 32.8048C42.599 32.3401 41.8274 32.3427 41.3359 32.8109Z"
        fill="#92D6FF"
      />
    </svg>
  )
}

export default BookViaCallIcon
